import { Koi } from '@ksyos/koi';
import type { IAddServiceActivity, IServiceWithActivities } from '@common/interfaces';
import type { IAddCarePathServiceEmploymentSettings } from '@common/interfaces/addCarePathServicesSettings';
import type { SettingsType } from '../../utils/settings';
import { settingsValidationSchema } from '../../utils/settings';
import { serviceSchema } from './addServiceConsumerSettings';

export interface IAddCarePathServiceEmploymentSettingsValidated extends IAddCarePathServiceEmploymentSettings {
    isDisabled?: boolean;
}

export interface IServiceEmploymentActivitiesSettingsValidated extends IServiceWithActivities<IAddServiceActivity> {
    settings: Partial<SettingsType>;
}

export const serviceEmploymentSettingsAdd = Koi.object()
    .keys({
        service: serviceSchema,
        serviceActivities: Koi.array().items(
            Koi.object().keys({
                canWrite: Koi.boolean(),
                enabled: Koi.boolean(),
                id: Koi.string().uuid(),
                name: Koi.string(),
            })
        ),
        settings: settingsValidationSchema,
    })
    .options({ convert: true });

export const addCarePathServiceEmploymentSettingsAdd = serviceEmploymentSettingsAdd.concat(
    Koi.object().keys({
        isDisabled: Koi.boolean().optional(),
        profileId: Koi.string(),
    })
);

export const serviceEmploymentActivitiesSettingsAdd = Koi.object()
    .keys({
        id: Koi.string().uuid(),
        serviceActivities: Koi.array().items(
            Koi.object().keys({
                canWrite: Koi.boolean(),
                id: Koi.string().uuid(),
                name: Koi.string(),
            })
        ),
        settings: settingsValidationSchema,
    })
    .options({ convert: true });
